<template>
    <div class="row">
        <div class="col-12 text-center">
            <div class="loading-spinner-container">
                <div class="spinner-block"></div>
                <div class="spinner-block"></div>
                <div class="spinner-block"></div>
                <div class="spinner-block"></div>
                <div class="spinner-block"></div>
                <div class="spinner-block"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoaderComponent"
    }
</script>

<style lang="scss">

    .loading-spinner-container {
        display: inline-block;
        position: relative;
        width: 2.5em;
        height: 2.5em;
    }

    .spinner-block {
        position: absolute;
        width: 0.55em;
        height: 0.55em;
        background: #202c38;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        transform-origin: 0 1.25em;
    }

    .loading-spinner-container div:nth-child(1) {
        transform: rotate(60deg);
        animation: loading-spinner-1 0.6s linear infinite;
        animation-delay: 0s;
    }

    .loading-spinner-container div:nth-child(2) {
        transform: rotate(120deg);
        animation: loading-spinner-2 0.6s linear infinite;
        animation-delay: 0.1s;
    }

    .loading-spinner-container div:nth-child(3) {
        transform: rotate(180deg);
        animation: loading-spinner-3 0.6s linear infinite;
        animation-delay: 0.2s;
    }

    .loading-spinner-container div:nth-child(4) {
        transform: rotate(240deg);
        animation: loading-spinner-4 0.6s linear infinite;
        animation-delay: 0.3s;
    }

    .loading-spinner-container div:nth-child(5) {
        transform: rotate(300deg);
        animation: loading-spinner-5 0.6s linear infinite;
        animation-delay: 0.4s;
    }

    .loading-spinner-container div:nth-child(6) {
        transform: rotate(360deg);
        animation: loading-spinner-6 0.6s linear infinite;
        animation-delay: 0.5s;
    }

    @keyframes loading-spinner-1 {
        0%, 33%, 80%, 100% {
            transform-origin: 0 1.25em;
        }

        16% {
            transform-origin: 0.25em 1.5em;
        }
    }

    @keyframes loading-spinner-2 {
        0%, 33%, 80%, 100% {
            transform-origin: 0 1.25em;
        }

        16% {
            transform-origin: 0.25em 1.5em;
        }
    }

    @keyframes loading-spinner-3 {
        0%, 33%, 80%, 100% {
            transform-origin: 0 1.25em;
        }

        16% {
            transform-origin: 0 1.5em;
        }
    }

    @keyframes loading-spinner-4 {
        0%, 33%, 80%, 100% {
            transform-origin: 0 1.25em;
        }

        16% {
            transform-origin: 0 1.5em;
        }
    }

    @keyframes loading-spinner-5 {
        0%, 33%, 80%, 100% {
            transform-origin: 0 1.25em;
        }

        16% {
            transform-origin: -0.25em 1.5em;
        }
    }

    @keyframes loading-spinner-6 {
        0%, 33%, 80%, 100% {
            top: 1.25em;
        }

        16% {
            top: 1em;
        }
    }
</style>